<template lang="pug">
rotator.absolute(:x='transform.x', :y='transform.y', v-bind='$props')
  slot
</template>

<script>
import Rotator from '@/components/Rotator'
export default {
  name: 'AngleRotator',
  components: { Rotator },
  props: {
    index: {
      type: [Number, String],
      required: false,
      default: 1,
    },
    count: {
      type: [Number, String],
      required: false,
      default: 1,
    },
    duration: {
      type: String,
      required: false,
      default: '5s',
    },
    reverse: {
      type: Boolean,
      required: false,
      default: false,
    },
    r: {
      type: [Number, String],
      required: false,
      default: 100,
    },
  },
  computed: {
    transform() {
      const angle = (this.index / this.count) * 2 * Math.PI
      const x = this.r * Math.cos(angle)
      const y = this.r * Math.sin(angle)
      return { x, y }
    },
  },
}
</script>
